import { INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getEditDefaultActionsData, getPreviewDefaultActionsData, getPrimaryDefaultActionsData, getRemoveDefaultActionsData } from '../default/getDefaultChickletHoverActions';
import { jsx as _jsx } from "react/jsx-runtime";
const useActions = args => {
  const {
    fromObjectTypeId
  } = args;
  return {
    PrimaryAction: getPreviewDefaultActionsData(args),
    SecondaryActions: [getPrimaryDefaultActionsData(args), getRemoveDefaultActionsData(args, {
      disabled: fromObjectTypeId === INVOICE_TYPE_ID,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.disabledInvoiceToPaymentTooltip"
      })
    }), getEditDefaultActionsData(args)]
  };
};
export default useActions;